import { render, staticRenderFns } from "./WasteResultDisplay.vue?vue&type=template&id=91a4a8b4&scoped=true&"
import script from "./WasteResultDisplay.vue?vue&type=script&lang=js&"
export * from "./WasteResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./WasteResultDisplay.vue?vue&type=style&index=0&id=91a4a8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a4a8b4",
  null
  
)

export default component.exports